import { useParams } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import Screen from "../../Layouts/Screen/Screen";
import { Heart, Trash } from "react-feather";
import Spinner from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { Post as PostType } from "../../../types";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import UserSearch from "../../Settings/SearchScreen/User/User";
import { useTranslation } from 'react-i18next';

const PostLikes = () => {
    const { id: postId } = useParams();
    const [likes, setLikes] = useState<any[]>([]);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPost, setIsLoadingPost] = useState(true);
    const { token } = useAuth();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [post, setPost] = useState<PostType>();  

    const loadLikes = async () => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);
        const url = `${PACOCA_API_URL}/posts/likes/${postId}/?limit=${LIMIT_REQUEST_COMMENTS}&offset=${offset}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            if (response.data.likes.length < LIMIT_REQUEST_COMMENTS) setHasMore(false);

            setLikes((prevLikes) => [...prevLikes, ...response.data.likes]);
            setOffset((prevOffset) => prevOffset + LIMIT_REQUEST_COMMENTS);
        } catch (error) {
            console.error("Erro ao carregar curtidas:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const loadPost = async () => {
        const url = PACOCA_API_URL + `/posts/${postId}`;
    
        // if (loading) return;
        setIsLoadingPost(true);
    
        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });
    
            const data = response.data;
    
            if (Array.isArray(data) && data.length > 0) {
                setPost(data[0]); // Pegando o primeiro item do array
            } else if (!Array.isArray(data)) {
                setPost(data); // Se for um objeto
            } else {
                // setEnd(true);
            }
        } catch (err: any) {
            console.error("Failed to load posts:", err);
            // if (err.response?.status === 401) setError(t("generics.errors.sessionExpired"));
            // if (err.response?.status === 429) setError(t("generics.errors.tooManyRequestsGeneric"));
        } finally {
            setIsLoadingPost(false);
        }
    };

    useEffect(() => {
        setLikes([]);
        setOffset(0);
        setHasMore(true);
        setIsLoading(true); // Inicia como true

        const fetchData = async () => {
            await loadLikes();
            await loadPost();
            setIsLoading(false); // Garante que o loading seja atualizado corretamente
        };
    
        fetchData();
    }, [postId]);

    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if (scrollTop + clientHeight >= scrollHeight - 50) {
                loadLikes();
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
            }
        };
    }, [loadLikes]);

    return (
        <Screen paddingTopTitle={true} title="Curtidas">
            <Helmet>
                <title>Paçoca - Likes</title>
                <meta name="description" content="Paçoca, sua nova rede social." />
            </Helmet>

            {isLoading || isLoadingPost ? (
                <div className="row user-select-none row-empty">
                    <Spinner className="text-primary" size="20" borderWidth="2" />
                </div>
            ) : (

                <>
                  {!post?.id && !isLoadingPost ? (
                    <div className="user-select-none row row-empty-comment">
                        <span className="span-empty">
                            <Trash className="icon-empty" />
                            <h3 className="w-100 text-center">Essa publicação foi apagada</h3>
                        </span>
                    </div>
                    ) : !isLoadingPost && likes.length === 0 ? (
                    <div className="row user-select-none row-empty">
                        <span className="span-empty">
                            <Heart className="icon-empty" data-feather="heart" />
                            <h3 className="w-100 text-center">Seja o primeiro a curtir</h3>
                        </span>
                    </div>
                    ) : (
                        // Renderiza a lista de curtidas normalmente
                        likes.map((user) => (
                            <UserSearch clasImgAccount="img-likes" clasNameSearch="name-likes" user={user}/>
                            // <div
                            //     key={user.user_name}
                            //     className="notification_opened row-notification open-notification"
                            //     onClick={() => (window.location.href = `/@${user.user_name}`)}
                            // >
                            //     <div
                            //         style={{
                            //             backgroundImage: `url('${user.img_account ? (BUCKET_PACOCA_URL + "/" + user.img_account) : "/img/img-account.png"}?t=${Date.now()}')`,
                            //         }}
                            //         className="col-1 img-likes"
                            //     ></div>
                            //     <div className="col" style={{ paddingLeft: "10px" }}>
                            //         <h5 className="name-likes">
                            //             <a className="name-likes" href={`/@${user.user_name}`}>
                            //                 {user.name}
                            //             </a>
                            //         </h5>
                            //         <p className="username-likes">
                            //             @{user.user_name} - {user.total_followers} seguidores
                            //         </p>
                            //     </div>
                            // </div>
                        ))
                    )}
  
                </>
            )}

        </Screen>
    );
};

export default PostLikes;
